import { IPublicClientApplication } from '@azure/msal-browser';
import { dvList, dvCreate, dvUpdate } from '../api/dataverseClient';

export interface StandupEntry {
  dagrun_pm_standupentryid: string;
  dagrun_pm_name: string;
  dagrun_pm_yesterday: string | null;
  dagrun_pm_today: string | null;
  dagrun_pm_blockers: string | null;
  dagrun_pm_entrydate: string | null;
  dagrun_pm_userid: string | null;
  dagrun_pm_username: string | null;
  _dagrun_pm_sprintid_value: string;
  _dagrun_pm_projectid_value: string;
}

const FIELDS = [
  'dagrun_pm_standupentryid','dagrun_pm_name','dagrun_pm_yesterday','dagrun_pm_today',
  'dagrun_pm_blockers','dagrun_pm_entrydate','dagrun_pm_userid','dagrun_pm_username',
  '_dagrun_pm_sprintid_value','_dagrun_pm_projectid_value',
];

function todayIsoDate(): string {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d.toISOString();
}

export async function getSprintStandups(pca: IPublicClientApplication, sprintId: string, dayIsoDate: string): Promise<StandupEntry[]> {
  // Filter for the specific date — match by date prefix.
  const day = new Date(dayIsoDate);
  const start = new Date(day); start.setHours(0,0,0,0);
  const end   = new Date(day); end.setHours(23,59,59,999);
  return dvList<StandupEntry>(pca, 'dagrun_pm_standupentries', {
    select: FIELDS,
    filter: `_dagrun_pm_sprintid_value eq ${sprintId} and dagrun_pm_entrydate ge ${start.toISOString()} and dagrun_pm_entrydate le ${end.toISOString()}`,
    orderby: 'createdon asc',
  });
}

export async function createStandupEntry(
  pca: IPublicClientApplication,
  fields: { sprintId: string; projectId: string; userId: string; userName: string; yesterday: string; today: string; blockers?: string | null },
): Promise<string> {
  return dvCreate(pca, 'dagrun_pm_standupentries', {
    dagrun_pm_name: `${fields.userName} — ${new Date().toLocaleDateString()}`,
    dagrun_pm_yesterday: fields.yesterday,
    dagrun_pm_today: fields.today,
    dagrun_pm_blockers: fields.blockers || null,
    dagrun_pm_entrydate: todayIsoDate(),
    dagrun_pm_userid: fields.userId,
    dagrun_pm_username: fields.userName,
    'dagrun_pm_sprintid@odata.bind': `/dagrun_pm_sprints(${fields.sprintId})`,
    'dagrun_pm_projectid@odata.bind': `/dagrun_pm_projects(${fields.projectId})`,
  });
}

export async function updateStandupEntry(
  pca: IPublicClientApplication,
  id: string,
  fields: { yesterday?: string; today?: string; blockers?: string | null },
): Promise<void> {
  const patch: Record<string, unknown> = {};
  if (fields.yesterday != null) patch.dagrun_pm_yesterday = fields.yesterday;
  if (fields.today != null)     patch.dagrun_pm_today = fields.today;
  if (fields.blockers !== undefined) patch.dagrun_pm_blockers = fields.blockers;
  return dvUpdate(pca, 'dagrun_pm_standupentries', id, patch);
}
